import { useContext } from "react";
import { RouterStateContext } from "../context.js";
export function useRouterState(selector) {
    const ctx = useContext(RouterStateContext);
    if (selector)
        return selector(ctx);
    return ctx;
}
